const CATEGORY_ORDER = [
  "performance",
  "accessibility",
  "best-practices",
  "seo",
  "agentic-browsing",
];

/** Match Issues tab order: category, then Lighthouse audit order within each. */
export function orderIssuesForDisplay(knownIssues) {
  const entries = Object.entries(knownIssues || {}).filter(
    ([, issue]) => issue?.score != null && issue.score < 1,
  );

  const byCategory = new Map();
  for (const [id, issue] of entries) {
    const cat = issue.category || "performance";
    if (!byCategory.has(cat)) byCategory.set(cat, []);
    byCategory.get(cat).push([id, issue]);
  }

  const ordered = [];
  for (const cat of CATEGORY_ORDER) {
    if (byCategory.has(cat)) ordered.push(...byCategory.get(cat));
  }
  for (const [cat, items] of byCategory) {
    if (!CATEGORY_ORDER.includes(cat)) ordered.push(...items);
  }

  return ordered.map(([id, issue], index) => ({
    id,
    issue,
    n: index + 1,
  }));
}
